// extracted by mini-css-extract-plugin
export default {"container":"S06_container__neUAS","limiter":"S06_limiter__FJoND"};